import isPropValid from '@emotion/is-prop-valid'
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import { UserRole } from './types'

export function resolveFilterValue(
  searchOptions: {
    label: string
    identifier: string
    placeholder?: string
    countries?: {
      label: string
      countryCode: string
    }[]
  }[],
  queryFilter?: undefined | string | string[] | qs.ParsedQs | qs.ParsedQs[]
) {
  let filter = _.isString(queryFilter) ? queryFilter : _.get(_.head(searchOptions), 'identifier', '')
  if (!filter || !_.find(searchOptions, so => so.identifier === filter)) {
    filter = _.get(_.head(searchOptions), 'identifier', '')
  }
  return filter
}

export function resolveQueryString(queryValue: undefined | string | string[] | qs.ParsedQs | qs.ParsedQs[]) {
  return _.isString(queryValue) ? queryValue : ''
}

export function getGlobalUniqueNumber() {
  return uuidv4()
}

export function shouldForwardProp(propName: string, target: any) {
  if (_.isString(target)) {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName)
  }
  // For other elements, forward all props
  return true
}

export function isAuthorizedForOrdering(isLoginAs: boolean, userRoles: UserRole[], loginAsRoles: UserRole[]): boolean {
  return (
    (isLoginAs && loginAsRoles && loginAsRoles.includes(UserRole.BRIQBuyReportPermission)) ||
    (!isLoginAs && (userRoles.includes(UserRole.BriqUser) || userRoles.includes(UserRole.BRIQBuyReportPermission)))
  )
}
